module.exports = __webpack_public_path__ + "static/heimat-03-ef42f337034ad83707b8cd975f2c574d.jpg";